import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactHookFormIntlNumberInput } from 'common/components/form';

import { handleOnBlurField } from '../../helpers';

const AnnualIncrease = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    const name = 'parameters.annual_increase';
    return (
        <ReactHookFormIntlNumberInput
            append="%"
            control={control}
            disabled={disabled}
            fullWidth
            label={t('Annual increase')}
            name={name}
            onBlur={({ value }) => handleOnBlurField({ name, setValue, value })}
        />
    );
};

AnnualIncrease.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default AnnualIncrease;
